/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import real from './../../../float64/real';
import imag from './../../../float64/imag';
import Complex128 from './../../../float64/ctor';

/**
* Returns the complex conjugate of a double-precision complex floating-point number.
*
* @param {Complex128} z - complex number
* @returns {Complex128} complex conjugate
*
* @example
* import Complex128 from '@stdlib/complex/float64/ctor';
*
* var z = new Complex128( 5.0, 3.0 );
*
* var v = conj( z );
* // returns <Complex128>[ 5.0, -3.0 ]
*/
function conj( z ) {
	return new Complex128( real( z ), -imag( z ) );
}


// EXPORTS //

export default conj;
